import { render, staticRenderFns } from "./AccountCollectionSchedule.vue?vue&type=template&id=72d7b1c4&"
import script from "./AccountCollectionSchedule.vue?vue&type=script&lang=js&"
export * from "./AccountCollectionSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports